<template>
	<BaseButton
			:text="loading ? 'Laden...' : 'Inloggen'"
			:disabled="loading"
			@click="$emit('login')"
	/>
</template>
<script setup lang="ts">
	import BaseButton from '~/components/generic/buttons/BaseButton.vue';

	defineProps({
		loading: {
			type: Boolean,
			required: true
		},
		authenticated: {
			type: Boolean,
			required: true
		}
	});

	defineEmits(['login']);
</script>
